enum CcManagerReportsActionType {
  REQUEST = '@CC_MANAGER_REPORT:REQUEST',
  SUCCESS = '@CC_MANAGER_REPORT:SUCCESS',
  FAIL = '@CC_MANAGER_REPORT:FAIL',
  CLEAN = '@CC_MANAGER_REPORT:CLEAN',
}

export default CcManagerReportsActionType;
